import { render, staticRenderFns } from "./ListarVentas.vue?vue&type=template&id=c86130b8&scoped=true&"
import script from "./ListarVentas.vue?vue&type=script&lang=js&"
export * from "./ListarVentas.vue?vue&type=script&lang=js&"
import style0 from "./ListarVentas.vue?vue&type=style&index=0&id=c86130b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86130b8",
  null
  
)

export default component.exports